import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "content", "underbar"]
  
  connect() {
    // 初期位置のアンダーバーを設定
    const activeButton = this.buttonTargets.find(button => button.classList.contains('active'))
    if (activeButton) {
      this.updateUnderbar(activeButton)
    } else if (this.buttonTargets.length > 0) {
      this.updateUnderbar(this.buttonTargets[0])
    }
    
    // ウィンドウリサイズ時にアンダーバーの位置を再計算
    this.handleResize = this.handleResize.bind(this)
    window.addEventListener('resize', this.handleResize)
  }
  
  disconnect() {
    window.removeEventListener('resize', this.handleResize)
  }
  
  handleResize() {
    const activeButton = this.buttonTargets.find(button => button.classList.contains('active'))
    if (activeButton) {
      this.updateUnderbar(activeButton)
    }
  }
  
  switch(event) {
    const tabName = event.target.dataset.tab
    const clickedButton = event.target
    
    // すべてのタブボタンを非アクティブにする
    this.buttonTargets.forEach(button => {
      button.classList.remove("active", "text-orange-500")
      button.classList.add("text-gray-700")
    })
    
    // クリックされたタブボタンをアクティブにする
    clickedButton.classList.remove("text-gray-700")
    clickedButton.classList.add("active", "text-orange-500")
    
    // アンダーバーを移動
    this.updateUnderbar(clickedButton)
    
    // すべてのコンテンツを隠す
    this.contentTargets.forEach(content => {
      content.classList.add("hidden")
    })
    
    // 選択されたコンテンツを表示
    const targetContent = this.contentTargets.find(content => content.dataset.tab === tabName)
    if (targetContent) {
      targetContent.classList.remove("hidden")
    }
  }
  
  updateUnderbar(activeButton) {
    if (!this.hasUnderbarTarget) return
    
    const underbar = this.underbarTarget
    const nav = activeButton.parentElement
    const navRect = nav.getBoundingClientRect()
    const buttonRect = activeButton.getBoundingClientRect()
    
    // アンダーバーの位置とサイズを更新
    const leftPosition = buttonRect.left - navRect.left
    const width = buttonRect.width
    
    underbar.style.left = `${leftPosition}px`
    underbar.style.width = `${width}px`
  }
}
